<style scoped>
    @import url("../../../styles/smartControl/histIrrig.scss");
</style>

<template>
    <div class="box_histIrrig">

        <div class="macro_el">
            <div class="tit ml-2">Histórico de irrigação</div>

            <div class="mb-2 mt-2">
                <v-chip color="#F5DDC0">{{ msgChipHist }}</v-chip>
            </div>

            <div class="backPainelExib" v-if="flagExibHist">

                <div class="painelExib mt-1 mb-1" v-for="(el,i) in liHistExib" :key="i">

                    <div class="card_el_info">
                        <span>Data:</span>
                        <span class="ml-2 el_info">{{ el.data }}</span>
                    </div>

                    <div class="card_el_info" v-if="'src_info' in el && el.src_info == 'stable_info'">
                        <span>Estabilização:</span>
                        <span class="ml-2 el_info">{{ Number(el.u_fc_stable).toFixed(2) }}%FC</span>
                    </div>

                    <div class="card_el_info" v-if="'irrig_decisor' in el">
                        <span>Decisor:</span>
                        <span class="ml-2 el_info">{{ el.irrig_decisor }}</span>
                    </div>

                    <div class="card_el_info" v-if="'setor_atuador' in el">
                        <span>Sector:</span>
                        <span class="ml-2 el_info">{{ el.setor_atuador }}</span>
                    </div>

                    <div class="card_el_info" v-if="'minutos' in el">
                        <span>Minutos de irrigação:</span>
                        <span class="ml-2 el_info">{{ el.minutos }}</span>
                    </div>

                    <div class="card_el_info" v-if="'nota' in el">
                        <span>Nota:</span>
                        <span class="ml-2 el_info">{{ el.nota }}</span>
                    </div>
                </div>
            </div>

            <div class="backBtnExpand mt-2" @click="expandHist()" v-if="flagExibBtnExpand">
                <v-btn 
                height="40px"
                width="40px"
                density="comfortable"
                icon
                :style="{'color':'green'}"
                >
                    <v-icon class="" size="16">mdi-plus</v-icon>
                </v-btn>
            </div>

        </div>

    </div>
</template>

<script>
import axios from 'axios'
import { convDdMmYyyyHhmmToIso, convFromUtc } from "../auxSC/handleTimeConv.js";

export default {

    data() {
        return {

            //
            liHist:[],
            liHistRecent:[],
            liHistExib:[],
            msgChipHist:'Informações recentes',
            flagExibHist:false,
            flagExibBtnExpand:false,
        }
    },

    methods:{

        expandHist() {
            //console.log('start')
            // -- trocar frase informativa.
            this.flagExibHist = false
            this.msgChipHist = `${this.liHist.length} informações`
            this.liHistExib = this.liHist
            this.flagExibBtnExpand = false
            this.flagExibHist = true
            //console.log('end')
        },

        async initHist() {
            
            let flagLoading = true // -- open loading
            this.$emit('boolFromChild', flagLoading) // father control

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let params = {
                'cliente':this.$store.state.emailCliente, 
                'sistema':this.$store.state.sistemaSC,
                'marcador':'irrig_hist'
            }

            let self = this
            const url = self.$store.state.pathAxiosBASE + '/getxcollxx'
            const res = await axios.post(url, params, {headers})

            //console.log(res.data.result)
            this.liHist = res.data.result

            if (this.liHist.length < 1) {
                this.msgChipHist = `Nenhuma informação disponível`
                this.flagExibHist = false
                return
            }

            //console.log('this.liHist[0] (utc): ',this.liHist[0])

            // -- conv dt str de utc para horario local
            const tzName = this.$store.state.fusoHorarioSC // esperado --> "Europe/Lisbon"
            let c = 0;
            while (c < this.liHist.length) {

                const dtIso = convDdMmYyyyHhmmToIso(
                    this.liHist[c]['data']
                );

                //if (c==0) { console.log('dtIso [c=0] (utc): ',dtIso) }

                const res = convFromUtc(dtIso, tzName);

                //if (c==0) { console.log('res.hhmm [c=0] (local): ',res.hhmm) }

                this.liHist[c]['data'] =
                    `${res.dataStr}-${res.hhmm}`;

                c++;
            }

            //console.log('this.liHist[0] (local): ',this.liHist[0])

            this.liHist = this.liHist.reverse() // [0] deve ser o mais recente

            if (this.liHist.length > 2) {
                let c = 0
                while (c < 3) {
                    //console.log(this.liHist[c])
                    this.liHistRecent.push(this.liHist[c])
                    c++
                }
                this.liHistExib = this.liHistRecent
                this.flagExibBtnExpand = true // apenas se houver expansão
            }
            else {
                this.liHistExib = this.liHist
            }
            //console.log(this.liHistExib)

            flagLoading = false // -- close loading
            this.$emit('boolFromChild', flagLoading) // father control

            this.flagExibHist = true
        },
    },

    async created() {
        //window.scrollTo(0,0)
        await this.initHist()
    }
}
</script>